import $ from "jquery";
import sliders from "./modules/sliders";
import maps from "./modules/map";
import search from "./modules/search";
import popout from "./modules/popout";
import filters from "./modules/filters";
import generic from "./modules/generic";
import menu from "./modules/menu";
import book from "./modules/book";
import Plyr from "plyr";

$(function () {
  $(".nss-tabs").tabs({ hide: "fade", show: "fade" });
  const players = Array.from(document.querySelectorAll(".player")).map(
    (p) =>
      new Plyr(p, {
        autoplay: false,
        controls: ["play-large"],
      })
  );
  $(".section-playlist_section .play").on("click", function (ev) {
    var $vid = $(this).attr("id");
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      players[$vid].pause();
    } else {
      $(".section-playlist_section .play").removeClass("active");
      if (
        $(this)
          .parents(".section-playlist_section")
          .find(".video-" + $vid)
          .hasClass("active")
      ) {
        $(this).addClass("active");
        players[$vid].play();
      } else {
        $(this).addClass("active");
        $(this).parents(".section-playlist_section").find(".video").fadeOut();
        $(this)
          .parents(".section-playlist_section")
          .find(".video")
          .removeClass("active");
        $(this)
          .parents(".section-playlist_section")
          .find(".video-" + $vid)
          .fadeIn();
        $(this)
          .parents(".section-playlist_section")
          .find(".video-" + $vid)
          .addClass("active");
        players[$vid].play();
      }
    }
  });
  $(window).on("load", function () {
    var videoHeight = $(
      ".section-playlist_section .video:first-child .plyr"
    ).height();
    $(".section-playlist_section .videos").height(videoHeight);
    $(".post-block").slideDown({
      duration: 3000,
      start: function () {
        $(this).css({
          display: "flex",
        });
      },
    });
  });
  $("#back").on("click", function () {
    parent.history.back();
    return false;
  });
});

$(function () {
  if ($("#map-container").length) {
    maps();
  }
  sliders();
  search();
  filters();
  popout();
  generic();
  menu();
  book();


  // JavaScript to handle hover effect
  const links = document.querySelectorAll('.overview-content a');
  const previewImage = document.getElementById('preview');

  links.forEach(link => {
    link.addEventListener('mouseenter', (e) => {
      // Set the src of the preview image to the href of the link
      previewImage.src = e.target.href;
      previewImage.style.display = 'block';
    });

    link.addEventListener('mousemove', (e) => {
      // Position the image near the cursor
      previewImage.style.left = e.pageX + 20 + 'px';
      previewImage.style.top = e.pageY + 20 + 'px';
    });

    link.addEventListener('mouseleave', () => {
      // Hide the preview image on mouse out
      previewImage.style.display = 'none';
    });
  });

  // home page course section mobile view click
  $(".course_hover").on("click", function (e) {
    e.preventDefault();
    var id = $(this).data("id");
    var status = $(this).data("status");
    if (status == 0) {
      $(".show-default-course-" + id).removeClass("opacity_1");
      $(".show-default-course-" + id).addClass("opacity_0");
      $(".show-hover-course-" + id).addClass("opacity_09");
      var status = $(this).data("status", 1);
      $(".course_btn_" + id).empty().append("<span>-</span>");
    } else {
      $(".show-default-course-" + id).removeClass("opacity_0");
      $(".show-default-course-" + id).addClass("opacity_1");
      $(".show-hover-course-" + id).removeClass("opacity_09");
      var status = $(this).data("status", 0);
      $(".course_btn_" + id).empty().text("+");
    }
  });
  // End home page course section mobile view click
});
